import { popularSerials } from '@/mocks/animeData';

export default function PopularSerials() {
  return (
    <section id="popular" className="scroll-mt-20 bg-background-100 px-4 py-12 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              人气连载
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              读者一路追更的高热度长篇连载，越看越上头
            </p>
          </div>
          <a
            href="#faq"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            常见问题 <i className="ri-question-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-4">
          {popularSerials.map((comic, idx) => (
            <article
              key={comic.id}
              className="group relative cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-secondary-300"
              data-product-shop
            >
              <div className="relative w-full overflow-hidden">
                <img
                  src={comic.image}
                  alt={`${comic.title} 人气连载漫画封面`}
                  title={`人气连载 ${comic.title} 更新至${comic.chapter}`}
                  className="aspect-[3/4] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-full bg-secondary-500 px-2 py-1 text-xs font-bold text-background-50">
                  <i className="ri-fire-fill"></i>
                  {comic.score}
                </span>
                <span className="absolute right-2 top-2 rounded-full bg-background-950/70 px-2 py-1 text-xs font-bold text-secondary-400 backdrop-blur-sm">
                  #{idx + 1}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-bold text-foreground-950 group-hover:text-secondary-700 md:text-base">
                  {comic.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-600">
                  {comic.desc}
                </p>
                <div className="mt-3 flex items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800">
                    {comic.genre}
                  </span>
                  <span className="ml-auto text-xs text-foreground-400">{comic.chapter}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}